import * as yup from 'yup';
import { ScaleRatingSuggestionSchema, SuggestionSchema } from '../../../common';

export const CarePlan2SuggestionSchema = yup.object({
  bladderControl: ScaleRatingSuggestionSchema.nullable(),
  continenceProfile: SuggestionSchema.nullable(),
  stoolControl: ScaleRatingSuggestionSchema.nullable(),
  copingUrinaryIncontinence: ScaleRatingSuggestionSchema.nullable(),
  copingStoolIncontinence: ScaleRatingSuggestionSchema.nullable(),
  usageToilet: ScaleRatingSuggestionSchema.nullable(),
  intertrigoRisk: SuggestionSchema.nullable(),
  careHead: ScaleRatingSuggestionSchema.nullable(),
  prosthesisCare: ScaleRatingSuggestionSchema.nullable(),
  handleGlasses: ScaleRatingSuggestionSchema.nullable(),
  handleHearingAid: ScaleRatingSuggestionSchema.nullable(),
  washingUpperBodyFront: ScaleRatingSuggestionSchema.nullable(),
  washingUpperBodyBack: ScaleRatingSuggestionSchema.nullable(),
  washingGenitalArea: ScaleRatingSuggestionSchema.nullable(),
  washingLowerBody: ScaleRatingSuggestionSchema.nullable(),
  showeringAndBathing: ScaleRatingSuggestionSchema.nullable(),
  dressingUpperBody: ScaleRatingSuggestionSchema.nullable(),
  dressingLowerBody: ScaleRatingSuggestionSchema.nullable(),
  habitsBaseCare: SuggestionSchema.nullable(),
  habitsClothing: SuggestionSchema.nullable(),
  measureDescription: SuggestionSchema.nullable(),
  incontinenceProductsDayOpen: SuggestionSchema.nullable(),
  incontinenceProductsDayClosed: SuggestionSchema.nullable(),
  incontinenceProductsNightOpen: SuggestionSchema.nullable(),
  incontinenceProductsNightClosed: SuggestionSchema.nullable(),
  infectionZystisProphylaxis: SuggestionSchema.nullable(),
  catheterDay: SuggestionSchema.nullable(),
  catheterNight: SuggestionSchema.nullable(),
  intertrigoProphylaxis: SuggestionSchema.nullable(),
  washingMorningCompletely: SuggestionSchema.nullable(),
  washingMorningPartly: SuggestionSchema.nullable(),
  washingMorningForm: SuggestionSchema.nullable(),
  washingMorningPartlyForm: SuggestionSchema.nullable(),
  washingEveningCompletely: SuggestionSchema.nullable(),
  washingEveningPartly: SuggestionSchema.nullable(),
  washingEveningForm: SuggestionSchema.nullable(),
  washingEveningPartlyForm: SuggestionSchema.nullable(),
  dressingType: SuggestionSchema.nullable(),
  oralCare: SuggestionSchema.nullable(),
  glassesMeasures: SuggestionSchema.nullable(),
  hearingAidMeasures: SuggestionSchema.nullable(),
  additionalMeasures: SuggestionSchema.nullable(),
  additionalInfo: SuggestionSchema.nullable(),
  goals: SuggestionSchema.nullable(),
});

export type ICarePlan2Suggestion = yup.InferType<typeof CarePlan2SuggestionSchema>;
